import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/home/WelcomeHome.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/providers/translation-provider.tsx")